// Thin re-export layer — the actual tracker lives in recentItems.js so it
// can be shared with clients + contacts.  All existing imports of
// getRecentMatters/pushRecentMatter/etc. keep working unchanged.

import { recentMattersTracker } from './recentItems'

export const getRecentMatters    = recentMattersTracker.get
export const pushRecentMatter    = recentMattersTracker.push
export const removeRecentMatter  = recentMattersTracker.remove
export const clearRecentMatters  = recentMattersTracker.clear
